import dayjs from 'dayjs'

import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'

import { AppCheckboxBadged } from '../../checkbox'
import { getDateLabel } from '../utils/getDateLabel'
import { getDisplayRangeEnd } from '../utils/getDisplayRangeEnd'
import { DateRange } from './Calendar.types'

type Props = {
  range: DateRange
  onRangeReset: () => void
  showDay?: boolean
  format?: 'date' | 'hours'
  /**
   * Показывать только конец промежутка вместо «начало - конец».
   * Нужно там, где промежуток лишь визуализирует срок от сегодня до выбранной даты.
   */
  showOnlyRangeEnd?: boolean
}

const getRangeLabel = (
  range: DateRange,
  showDay: boolean,
  showOnlyRangeEnd: boolean
) =>
  showOnlyRangeEnd && range.to
    ? getDateLabel({ from: range.to }, showDay)
    : getDateLabel(range, showDay)

const getHoursRangeLabel = (range: DateRange) => {
  const from = range.from

  if (!from) {
    return ''
  }

  const nextHourStart = range.to ?? dayjs(from).add(1, 'hour').toDate()
  const displayTo = getDisplayRangeEnd(nextHourStart)
  const zonedFrom = dayjs(from).tz(DEFAULT_TIMEZONE)

  return `${zonedFrom.format('HH:mm')} - ${dayjs(displayTo)
    .tz(DEFAULT_TIMEZONE)
    .format('HH:mm')}, ${zonedFrom.format('D MMMM')}`
}

export const CalendarRangeBadge = ({
  range,
  onRangeReset,
  showDay = true,
  format = 'date',
  showOnlyRangeEnd = false
}: Props) => (
  <AppCheckboxBadged
    label={
      format === 'hours'
        ? getHoursRangeLabel(range)
        : getRangeLabel(range, showDay, showOnlyRangeEnd)
    }
    labelClassName="text-16"
    checked={true}
    onChange={onRangeReset}
  />
)
